import React, { useEffect, useState } from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { MAIN_WHATSAPP_MESSAGE } from '../data/messages';
import { whatsappUrl } from '../utils/whatsapp';
import { trackWhatsAppClick } from '../utils/analytics';
export function FloatingWhatsApp() {
  // En móvil, la barra se oculta dentro del cotizador para no tapar su propio resumen de pedido
  const [insideBuilder, setInsideBuilder] = useState(false);
  useEffect(() => {
    const el = document.getElementById('cotizador');
    if (!el || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(([entry]) => setInsideBuilder(entry.isIntersecting), {
      rootMargin: '-45% 0px -45% 0px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <>
      <div aria-hidden={insideBuilder} className={`fixed inset-x-0 bottom-0 z-50 flex gap-2 border-t border-navy-700 bg-navy-900/95 px-3 pt-2.5 backdrop-blur transition-transform duration-200 ease-out lg:hidden ${insideBuilder ? 'pointer-events-none translate-y-full' : 'translate-y-0'}`} style={{
      paddingBottom: 'calc(0.625rem + env(safe-area-inset-bottom))'
    }} data-id="element-59" data-mp="35tf5ermyn60z">
        <a href="#cotizador" tabIndex={insideBuilder ? -1 : 0} className="flex flex-1 items-center justify-center whitespace-nowrap rounded-md border border-white/25 px-3 py-3 text-sm font-semibold text-white" data-id="element-60" data-mp="3fgiudurxz26t">
          Ver precios
        </a>
        <a href={whatsappUrl(MAIN_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" tabIndex={insideBuilder ? -1 : 0} onClick={() => trackWhatsAppClick('barra_movil', 'cotizacion')} className="flex flex-[2] items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-3 py-3 text-sm font-semibold text-white transition-[background-color,transform] duration-150 ease-out active:scale-[0.98]" data-id="element-61" data-mp="g0ciealmzcn1">
          <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-62" data-mp="x9yb5sq80ygn" />
          Cotizar por WhatsApp
        </a>
      </div>

      <a href={whatsappUrl(MAIN_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick('boton_flotante', 'cotizacion')} className="fixed bottom-6 right-6 z-50 hidden items-center gap-2 rounded-full bg-accent-500 px-5 py-4 font-semibold text-white shadow-xl shadow-black/25 transition-[background-color,transform] duration-150 ease-out hover:bg-accent-600 active:scale-[0.98] lg:inline-flex" data-id="element-63" data-mp="sbmyla8jk9uq">
        <MessageCircleIcon className="h-6 w-6" aria-hidden="true" data-id="element-64" data-mp="4jzfhehiu330" />
        Cotizar por WhatsApp
      </a>
    </>;
}